// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ApplyToAll: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M34.6 18l-.7-.4c-.4-.2-1-.1-1.3.2l-8.8 13.8-4.3-4.3c-.4-.4-1-.4-1.4 0l-.5.6c-.4.4-.4 1 0 1.4l5.7 5.6c.2.2.4.3.7.3h.1c.3 0 .6-.2.8-.5l9.9-15.3c.3-.4.3-.9-.2-1.4z"/><path d="M42.5 8.7h-7.2V1.5c0-.6-.4-1-1-1H1.5c-.6 0-1 .4-1 1v32.8c0 .6.4 1 1 1h7.2v7.2c0 .6.4 1 1 1h32.8c.6 0 1-.4 1-1V9.7c0-.5-.5-1-1-1zM3 32.8V3h29.8v5.7h-23c-.6 0-1 .4-1 1v23H3zM41 41H11.2V11.2H41V41z"/></svg>;
};

export default React.memo(ApplyToAll);
